module.exports = __webpack_public_path__ + "static/media/darkTheme.9d0f2776.png";